import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from '@features/userPanel/components/Orders/OrderDetails.styles';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import CartProductImage from '@features/cart/components/CartProductImage/CartProductImage';
import CartProductDescription from '@features/cart/components/CartProductDescription/CartProductDescription';
import CartProductQuantity from '@features/cart/components/CartProductQuantity/CartProductQuantity';
import CartProductPrices from '@features/cart/components/CartProductPrices/CartProductPrices';
import Checkbox from '@components/Checkbox/Checkbox';
import { PositionType } from '@features/userPanel/typescript';
type PropsType = {
  positions: Array<PositionType>;
  isStorAssemblyAvailable?: boolean;
  selectable?: boolean;
  selectedPositionIds?: Array<string>;
  onTogglePosition?: (positionId: string) => void;
};
const OrderPositions = ({
  positions,
  isStorAssemblyAvailable = false,
  selectable = false,
  selectedPositionIds = [],
  onTogglePosition
}: PropsType) => <ul sx={styles.productsContainer}>
    {positions.map((position: PositionType) => {
    const {
      positionId,
      image,
      quantity,
      availability,
      prices,
      name,
      configuration,
      unitType,
      quantityType,
      multiplication
    } = position;
    const isDip = unitType === 'square_meters' && quantityType === 'package';
    const isSelected = selectedPositionIds.includes(positionId);
    return <ErrorBoundary key={positionId}>
          <li sx={styles.productContainer(selectable)} data-cy={selectable ? 'ReturnProductItem' : 'PositionItem'}>
            {selectable && <div sx={styles.productCheckbox}>
                <Checkbox value={isSelected} onChange={() => onTogglePosition?.(positionId)} cy={`ReturnProductCheckbox-${positionId}`} />
              </div>}
            <div sx={styles.productContainerInner(selectable)}>
              <div sx={styles.productDetails}>
                {image ? <CartProductImage image={image} availability miniCart={false} /> : <Skeleton count={1} height={100} width={100} />}
                <CartProductDescription productName={name} productTypeName={position.productType?.name || ''} productDescription={configuration?.description || ''} quantityType={quantityType || 'pcs'} />
              </div>
              <CartProductQuantity quantity={quantity || 1} availability={availability} isProductLoading={false} showAvailabilityDate={false} allowChangeQuantity={false} miniCart={false} date={0} showProductInfo classNames={styles.quantityContainer} onChangeQty={() => undefined} isDip={isDip} multiplication={multiplication || ''} />
            </div>
            <div sx={styles.priceDetails}>
              <div sx={styles.priceContainer}>
                <CartProductPrices prices={prices} isProductLoading={false} isStorAssemblyAvailable={isStorAssemblyAvailable} />
              </div>
            </div>
          </li>
        </ErrorBoundary>;
  })}
  </ul>;
export default OrderPositions;